// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'dec379c265f0ecff92c4e19977e77c30cb50ae01';
export const BUILD_NUMBER = '208';
export const BUILD_TIMESTAMP = '2026-07-24T05:30:46.077Z';
